import { FIXED_ABBRS } from "./variables";
import moment from 'moment-timezone';


export const generateTenMinuteTimestamps = (moment: any, startHour: any, endHour: any) => {
    const start = moment(startHour);
    const end = moment(endHour);

    const timestamps = [];

    while (start <= end) {
        timestamps.push(start.toISOString());
        start.add(10, 'minutes');
    }

    return timestamps;
}

export const getTzAbbrForce = (tz: string, date: Date = new Date()): string => {
    const zone = moment.tz.zone(tz);
    if (!zone) return '';
    const ab = zone.abbr(date.getTime());
    return FIXED_ABBRS[tz] || ab;
}

// Intl/luxon short zone names come from CLDR(Unicode Common Locale Data Repository),
// which still treats Alberta, BC and Manitoba as
// changing clocks (e.g. Edmonton shows MDT/MST instead of CST).
// Only when Intl gives a letter
// abbreviation is it replaced by the IANA one; offset names like "GMT+8" are kept as they are.
export const getTzAbbrOrFallback = (tz: string, date: Date, fallback: string): string => {
    const ab = getTzAbbrForce(tz, date);
    const isLetters = (value: string) => /^[A-Za-z]+$/.test(value);
    return isLetters(fallback) && isLetters(ab) ? ab : fallback;
}